import {
  Avatar,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListProps,
  Typography,
} from "@material-ui/core";
import React from "react";
import { useHistory, useLocation } from "react-router";
import { UserArtist } from "../../../../../../services/user-admin/types/api/user-details-response";

interface UserArtistListProps extends ListProps {
  artists: UserArtist[];
}

export const UserArtistList: React.FC<UserArtistListProps> = ({
  artists,
  ...props
}) => {
  const history = useHistory();
  const location = useLocation();

  const gotoArtist = (artistId: string) => history.push(`/artists/${artistId}`, location.state);

  return (
    <React.Fragment>
      <Typography variant="h5" style={{ flexGrow: 1, marginTop: "20px" }}>
        Artists
      </Typography>
      <List {...props}>
        {artists.map((artist) => (
          <React.Fragment key={artist.id}>
            <ListItem
              alignItems="flex-start"
              button
              onClick={() => gotoArtist(artist.id)}
            >
              <ListItemAvatar>
                <Avatar alt={artist.name} src={artist.avatar} />
              </ListItemAvatar>
              <ListItemText primary={artist.name} />
            </ListItem>
            <Divider variant="inset" component="li" />
          </React.Fragment>
        ))}
      </List>
    </React.Fragment>
  );
};
